export const app_themes = {
  eva: {
    login_logo_path: './assets/images/logo_bleu_horizontal.png',
    logo_path: './assets/images/logo.png',
    logo_alt: 'Logo Eva',
    favicon_path: './assets/images/eva_favicon.ico',
    app_title: 'EVA by LiveE',
    copyright: 'The Event App',


    // Basic Colors
    '--navy': '#1ab394', // Primary color
    '--navy-darken-2': '#19aa8d',
    '--navy-darken-3': '#18a689',
    '--navy-darken-5': '#179d82',
    '--navy-darken-6': '#16987e',
    '--navy-lighten-3': '#1cc09f',
    '--navy-lighten-4': '#1dc5a3',
    '--dark-gray': '#c2c2c2', // Default color
    '--dark-gray-darken-6': '#b3b3b3',
    '--blue': '#1c84c6', // Success color
    '--blue-darken-2': '#1b7ebd',
    '--blue-darken-3': '#1a7bb9',
    '--blue-darken-6': '#1872ab',
    '--blue-lighten-4': '#1f90d8',
    '--lazur': '#23c6c8', // Info color
    '--lazur-darken-3': '#21b9bb',
    '--lazur-darken-6': '#1eacae',
    '--lazur-lighten-4': '#26d7d9',
    '--yellow': '#f8ac59', // Warning color
    '--yellow-darken-3': '#f7a54a',
    '--yellow-darken-6': '#f79d3c',
    '--red': '#ED5565', // Danger color
    '--red-darken-3': '#ec4758',
    '--red-darken-6': '#ea394c',
    '--red-lighten-4': '#ef6776',

    // Various colors
    '--text-color': '#676a6c', // Body text
    '--text-color-darken-5': '#5b5d5f',
    '--text-color-lighten-10': '#808486',
    '--text-color-lighten-20': '#9a9d9f',
    '--text-color-lighten-25': '#a7aaab',
    '--text-color-lighten-30': '#b4b6b8',
    '--text-color-lighten-35': '#c1c3c4',
    '--text-color-lighten-40': '#ced0d1',
    '--text-color-lighten-50': '#e8e9ea',
    '--gray': '#f3f3f4', // Background wrapper color
    '--gray-darken-3': '#ebebed',
    '--gray-darken-20': '#bebec3',
    '--gray-lighten-2': '#f8f8f9',
    '--gray-lighten-3': '#fbfbfb',
    '--light-gray': '#D1DADE', // Default label, badge
    '--label-badge-color': '#5E5E5E',
    '--light-blue': '#f3f6fb',
    '--red-primary': '#010938',

    // Spiner color and margin
    '--spin-color': '--navy',
    '--spin-margin': '0 auto',

    // IBOX colors ( default panel colors)
    '--border-color': '#e7eaec', // IBox border
    '--ibox-title-bg': '#ffffff', // IBox Background header
    '--ibox-content-bg': '#ffffff', // IBox Background content

    //Sidebar
    '--sidebar-width': '220px',
    '--sidebar-bg': '#000938',
    '--sidebar-separator-bg': '#1A224C',
    '--sidebar-item': '#fff',

    '--global-bg': '',
    '--nav-header-background': 'url("assets/styles/patterns/4.png") no-repeat',
    '--skin-1-nav-header-background-image':
      'url("assets/styles/patterns/header-profile-skin-1.png")',
    '--skin-2-nav-header-background-image':
      'url("assets/styles/patterns/header-profile-skin-2.png")',
    '--skin-3-nav-header-background-image':
      'url("assets/styles/patterns/header-profile-skin-3.png")',
    '--blue-skin-background':
      'url("assets/styles/patterns/header-profile-skin-1.png") repeat scroll 0 0',
    '--yellow-skin-background':
      'url("assets/styles/patterns/header-profile-skin-3.png") repeat scroll 0 100%',
    '--ultra-skin-background': 'url("assets/styles/patterns/3.png") repeat scroll 0 0',
    '--ultra-skin-hover-background': 'url("assets/styles/patterns/4.png") repeat scroll 0 0',

    // Boxed layout width
    '--boxed-width': '1200px',
    '--boxed-background': 'url("assets/styles/patterns/shattered.png")',

    //Border radius for buttons
    '--btn-border-radius': '3px',

    //Navigation
    '--nav-bg': '#2F4050',
    '--nav-bg-darken-3': '#293846',
    '--nav-bg-lighten-2': '#334556',
    '--nav-profile-pattern': 'url("assets/styles/patterns/header-profile.png")',
    '--nav-text-color': '#a7b1c2',
    '--nav-text-hover': '#000',

    '--bg': '#b3b3b3',
    '--font': '#000',
    '--font-darken-2': '#000938',
    '--font-light': '#FFF',
    '--grey-bg': '#f3f3f4',
    '--primary': '#33a06e',
    '--primary-opacify-0.75': 'rgba(51, 160, 110, 0.75)',
    '--header': '#010938',
    '--header-darken-5': '#01051f',
    '--header-darken-10': '#000106',
    '--light-primary': '#99ffcd',
    '--light-primary-opacify-0.5': 'rgba(153, 255, 205, 0.5)',
    '--dark-primary': '#51f4b1',
    '--secondary': '#41c18c',
    '--grey': '#737373',
    '--light-grey': '#eaeaea',
    '--light-grey-darken-5': '#dddddd',
    '--dark-grey': '#3e3e3e',
    '--light-green': '#9bc65c',
    '--dark-green': '#61af1c',
    '--dark-blue': '#3e9a91',
    '--mdc-theme-primary': '--primary',
    '--mdc-theme-text-primary-on-light': '--secondary',
    '--mdc-theme-secondary': '--light-green',
    '--mdc-theme-background': '--grey-bg',

    '--marketplace-bg': '#cfd8dc',
    '--marketplace-title': '#b0bec5',

    '--pretty--color-default': '--light-grey',
    '--pretty--color-primary': '--primary',
    '--pretty--color-info': '--light-primary',
    '--pretty--color-success': '--dark-primary',
    '--pretty--color-warning': '--secondary',
    '--pretty--color-danger': '--red',
    '--pretty--color-dark': '--dark-grey'
  },
  mylivetv: {
    login_logo_path: './assets/images/mltv-logo-color-horizontal.png',
    logo_path: './assets/images/mylivetv_logo.png',
    logo_alt: 'Logo MyLiveTV',
    favicon_path: './assets/images/mltv_favicon.ico',
    app_title: 'MyLiveTV by LiveE',
    copyright: 'MyLiveTV',

    // Basic Colors
    '--navy': '#ff4800', // Primary color
    '--navy-darken-2': '#f9aa8d',
    '--navy-darken-3': '#f8a689',
    '--navy-darken-5': '#f79d82',
    '--navy-darken-6': '#f6987e',
    '--navy-lighten-3': '#fcc09f',
    '--navy-lighten-4': '#fdc5a3',
    '--dark-gray': '#c2c2c2', // Default color
    '--dark-gray-darken-6': '#b3b3b3',
    '--blue': '#1c84c6', // Success color
    '--blue-darken-2': '#1b7ebd',
    '--blue-darken-3': '#1a7bb9',
    '--blue-darken-6': '#1872ab',
    '--blue-lighten-4': '#1f90d8',
    '--lazur': '#23c6c8', // Info color
    '--lazur-darken-3': '#21b9bb',
    '--lazur-darken-6': '#1eacae',
    '--lazur-lighten-4': '#26d7d9',
    '--yellow': '#f8ac59', // Warning color
    '--yellow-darken-3': '#f7a54a',
    '--yellow-darken-6': '#f79d3c',
    '--red': '#ED5565', // Danger color
    '--red-darken-3': '#ec4758',
    '--red-darken-6': '#ea394c',
    '--red-lighten-4': '#ef6776',

    // Various colors
    '--text-color': '#676a6c', // Body text
    '--text-color-darken-5': '#5b5d5f',
    '--text-color-lighten-10': '#808486',
    '--text-color-lighten-20': '#9a9d9f',
    '--text-color-lighten-25': '#a7aaab',
    '--text-color-lighten-30': '#b4b6b8',
    '--text-color-lighten-35': '#c1c3c4',
    '--text-color-lighten-40': '#ced0d1',
    '--text-color-lighten-50': '#e8e9ea',
    '--gray': '#c3f3f4', // Background wrapper color
    '--gray-darken-3': '#cbebed',
    '--gray-darken-20': '#cebec3',
    '--gray-lighten-2': '#c8f8f9',
    '--gray-lighten-3': '#cbfbfb',
    '--light-gray': '#f1DADE', // Default label, badge
    '--label-badge-color': '#fE5E5E',
    '--light-blue': '#c3f6fb',
    '--red-primary': '#f10938',

    // Spiner color and margin
    '--spin-color': '--navy',
    '--spin-margin': '0 auto',

    // IBOX colors ( default panel colors)
    '--border-color': '#f7eaec', // IBox border
    '--ibox-title-bg': '#cfffff', // IBox Background header
    '--ibox-content-bg': '#ffffff', // IBox Background content

    //Sidebar
    '--sidebar-width': '220px',
    '--sidebar-bg': '#FFFFFF',
    '--sidebar-separator-bg': '#ff4800',
    '--sidebar-item': '#111',

    '--global-bg': '',
    '--nav-header-background': 'url("assets/styles/patterns/4.png") no-repeat',
    '--skin-1-nav-header-background-image':
      'url("assets/styles/patterns/header-profile-skin-1.png")',
    '--skin-2-nav-header-background-image':
      'url("assets/styles/patterns/header-profile-skin-2.png")',
    '--skin-3-nav-header-background-image':
      'url("assets/styles/patterns/header-profile-skin-3.png")',
    '--blue-skin-background':
      'url("assets/styles/patterns/header-profile-skin-1.png") repeat scroll 0 0',
    '--yellow-skin-background':
      'url("assets/styles/patterns/header-profile-skin-3.png") repeat scroll 0 100%',
    '--ultra-skin-background': 'url("assets/styles/patterns/3.png") repeat scroll 0 0',
    '--ultra-skin-hover-background': 'url("assets/styles/patterns/4.png") repeat scroll 0 0',

    // Boxed layout width
    '--boxed-width': '1200px',
    '--boxed-background': 'url("assets/styles/patterns/shattered.png")',

    //Border radius for buttons
    '--btn-border-radius': '3px',

    //Navigation
    '--nav-bg': '#fF4050',
    '--nav-bg-darken-3': '#f93846',
    '--nav-bg-lighten-2': '#f34556',
    '--nav-profile-pattern': 'url("assets/styles/patterns/header-profile.png")',
    '--nav-text-color': '#ff4800',
    '--nav-text-hover' : '#FFF',

    '--bg': '#c3b3b3',
    '--font': '#000',
    '--font-darken-2': '#000',
    '--font-light': '#cFF',
    '--grey-bg': '#f3f3f4',
    '--primary': '#ff4800',
    '--primary-opacify-0.75': 'rgba(151, 160, 110, 0.75)',
    '--header': '#333333',
    '--header-darken-5': '#111111',
    '--header-darken-10': '#000000',
    '--light-primary': '#ffede7',
    '--light-primary-opacify-0.5': 'rgba(153, 155, 105, 0.5)',
    '--dark-primary': '#ff4800',
    '--secondary': '#000',
    '--grey': '#737373',
    '--light-grey': '#eaeaea',
    '--light-grey-darken-5': '#dddddd',
    '--dark-grey': '#3e3e3e',
    '--light-green': '#d6f6f6',
    '--dark-green': '#f1af1c',
    '--dark-blue': '#fe9a91',
    '--mdc-theme-primary': '--primary',
    '--mdc-theme-text-primary-on-light': '--secondary',
    '--mdc-theme-secondary': '--light-green',
    '--mdc-theme-background': '--grey-bg',

    '--marketplace-bg': '#ffd8dc',
    '--marketplace-title': '#f0bec5',

    '--pretty--color-default': '--light-grey',
    '--pretty--color-primary': '--primary',
    '--pretty--color-info': '--light-primary',
    '--pretty--color-success': '--dark-primary',
    '--pretty--color-warning': '--secondary',
    '--pretty--color-danger': '--red',
    '--pretty--color-dark': '--dark-grey'
  }
};



// WEBPACK FOOTER //
// ./src/app/theme/themes.const.ts